import web3 from 'web3';

const walletAddressValidator = (address: string): boolean => {
  return web3.utils.isAddress(address);
};

export default walletAddressValidator;
